/* Midway collection redesign (added by Claude, draft theme) */
(function () {
  if (window.mwCollectionInit) return;
  window.mwCollectionInit = true;

  /* Keep ?view=midway-team on filter, sort, chip, tab and pagination links.
     Only matters while previewing with ?view=; once the template is assigned to a
     collection there is no view parameter and this does nothing. */
  var view = new URLSearchParams(window.location.search).get('view');
  function withView(href) {
    if (!view || !href) return href;
    try {
      var u = new URL(href, window.location.origin);
      if (u.origin !== window.location.origin) return href;
      u.searchParams.set('view', view);
      return u.pathname + u.search + u.hash;
    } catch (e) { return href; }
  }
  function keepView() {
    if (!view) return;
    document.querySelectorAll('.mw-chips a, .mw-pages a, .mw-empty a, .mw-tabs a').forEach(function (a) {
      a.setAttribute('href', withView(a.getAttribute('href')));
    });
    document.querySelectorAll('form.mw-filters').forEach(function (f) {
      if (f.querySelector('input[name="view"]')) return;
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'view';
      i.value = view;
      f.appendChild(i);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', keepView);
  } else {
    keepView();
  }

  function readVariants(card) {
    var el = card.querySelector('[data-mw-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function renderSizes(card, color) {
    var wrap = card.querySelector('[data-mw-sizes]');
    if (!wrap) return;
    var list = readVariants(card).filter(function (v) { return v[1] === color; });
    if (!list.length) return;
    wrap.textContent = '';
    list.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mw-size';
      b.setAttribute('data-mw-size', v[0]);
      b.textContent = v[2];
      if (!v[3]) {
        b.disabled = true;
        b.setAttribute('aria-label', 'Size ' + v[2] + ' sold out');
      } else {
        b.setAttribute('aria-label', 'Add size ' + v[2] + ' to cart');
      }
      wrap.appendChild(b);
    });
  }

  function selectColor(card, swatch) {
    card.querySelectorAll('.mw-swatch').forEach(function (s) {
      s.setAttribute('aria-pressed', s === swatch ? 'true' : 'false');
    });
    var img = card.querySelector('.mw-card__img');
    var src = swatch.getAttribute('data-mw-src');
    if (img && src) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
    }
    var variant = swatch.getAttribute('data-mw-variant');
    if (variant) {
      card.querySelectorAll('[data-mw-link]').forEach(function (a) {
        var base = a.getAttribute('href').split('?')[0];
        a.setAttribute('href', base + '?variant=' + variant);
      });
      var input = card.querySelector('.mw-atc__form input[name="id"]');
      if (input) input.value = variant;
    }
    var color = swatch.getAttribute('data-mw-color');
    var label = card.querySelector('[data-mw-color-label]');
    if (label) label.textContent = ' \u00b7 ' + color;
    renderSizes(card, color);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var swatch = t.closest('.mw-swatch');
    if (swatch) {
      e.preventDefault();
      selectColor(swatch.closest('[data-mw-card]'), swatch);
      return;
    }

    var size = t.closest('[data-mw-size]');
    if (size && !size.disabled) {
      var card = size.closest('[data-mw-card]');
      var form = card && card.querySelector('.mw-atc__form');
      var input = form && form.querySelector('input[name="id"]');
      if (!input) return;
      input.value = size.getAttribute('data-mw-size');
      size.setAttribute('aria-busy', 'true');
      if (typeof form.requestSubmit === 'function') { form.requestSubmit(); } else { form.submit(); }
      setTimeout(function () {
        size.removeAttribute('aria-busy');
        var d = card.querySelector('.mw-atc__details');
        if (d) d.removeAttribute('open');
      }, 1200);
      return;
    }

    if (t.closest('.mw-atc__close')) {
      var det = t.closest('details');
      if (det) det.removeAttribute('open');
      return;
    }
    if (t.closest('[data-mw-open-filters]')) {
      document.documentElement.classList.add('mw-filters-open');
      return;
    }
    if (t.closest('[data-mw-close-filters]')) {
      document.documentElement.classList.remove('mw-filters-open');
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var filters = t.closest('form.mw-filters');
    if (filters) {
      if (t.matches('[data-mw-group]')) {
        var g = t.closest('.mw-g');
        if (g) g.querySelectorAll('[data-mw-member]').forEach(function (i) { i.disabled = !t.checked; });
      }
      filters.submit();
      return;
    }
    if (t.matches('[data-mw-sort]')) {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', t.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    }
  });
})();
